import { render, staticRenderFns } from "./SystemDuplicates.vue?vue&type=template&id=31c95163&scoped=true&"
import script from "./SystemDuplicates.vue?vue&type=script&lang=js&"
export * from "./SystemDuplicates.vue?vue&type=script&lang=js&"
import style0 from "./SystemDuplicates.vue?vue&type=style&index=0&id=31c95163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c95163",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c95163')) {
      api.createRecord('31c95163', component.options)
    } else {
      api.reload('31c95163', component.options)
    }
    module.hot.accept("./SystemDuplicates.vue?vue&type=template&id=31c95163&scoped=true&", function () {
      api.rerender('31c95163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemDuplicates.vue"
export default component.exports